import { format } from "date-fns";
import React, { useState } from "react";
import { Dropdown, OverlayTrigger, Popover } from "react-bootstrap";
import {
  AiFillCaretRight,
  AiFillEye,
  AiFillHome,
  AiFillPhone,
  AiOutlineCheck,
  AiOutlineClockCircle,
  AiOutlineSend,
} from "react-icons/ai";
import { PiNoteFill } from "react-icons/pi";
import { BsPersonCircle, BsThreeDots } from "react-icons/bs";
import { useAuth } from "../../Context/AuthContext";
import { MdClose } from "react-icons/md";
import { FaRegTrashAlt, FaTrash } from "react-icons/fa";
import {
  changeDateFormatYYYY,
  format24Time,
  formatAMPM,
  onStartSession,
  showToastError,
  showToastSuccess,
} from "../../Utils/Helper";
import { createZoomMeetingService } from "../../services/ZoomService";
import { useNavigate } from "react-router-dom";
import {
  confirmBookingStatus,
  getBookingByDate,
  rescheduleSlots,
} from "../../services/DoctorService";
import CalendarWeek from "../calendar/CalenderWeek";
import { AddReminder } from "../../services/ReminderService";
import { toastMsg } from "../../Utils/AllConstant";
import moment from "moment";
import Popup from "../../commonComponent/Popup";

function PopoverList({ dt, setAppointId, getTodaysBookingList }) {
  // console.log(dt);
  const navigate = useNavigate();
  const auth = useAuth();
  // const [data, setData] = useState(null);
  // const [error, setError] = useState(false);
  // const [showDetails, setShowDetails] = useState(false);
  const [date1, setDate1] = useState("");
  const [rescheduleStartTime, setRescheduleStartTime] = useState("");
  const [rescheduleEndTime, setRescheduleEndTime] = useState("");
  const [rescheduleTime, setRescheduleTime] = useState("");
  const [timeList, setTimeList] = useState([]);
  const [BookingList1, setBookingList1] = useState([]);
  const [status, setStatus] = useState("");
  const [bookingId, setBookingId] = useState("");
  const [request, setRequest] = useState({});
  const [sessionType, setSessionType] = useState("");
  const [sessionWith, setSessionWith] = useState("");
  const [startTime, setStartTime] = useState("");
  const [endTime, setEndTime] = useState("");
  const [attend, setAttend] = useState("");
  const [popClose, setPopClose] = useState(false);
  const [date, setDate] = useState(new Date());
  // const [BookingList, setBookingList] = useState([]);
  const [confirmMessage, setConfirmMessage] = useState("");
  const [phone, setPhone] = useState();
  const [location, setLocation] = useState();
  const [link, setLink] = useState();

  // let initialDate = format(new Date(), "yyyy-MM-dd");

  // const updateAppointmentBooking = async (payload) => {
  //   try {
  //     const response = await confirmBookingStatus(payload);
  //     if (response.status === 200) {
  //       showToastSuccess(response?.data?.message);
  //       getTodaysBookingList(initialDate);
  //     } else {
  //       showToastError(response?.data || response.message);
  //     }
  //   } catch (error) {
  //     error?.data?.data &&
  //       showToastError(error?.data?.data || error.data?.message);
  //   }
  // };

  const getTodaysBookingList1 = async (date) => {
    try {
      const response = await getBookingByDate(date);
      if (response.status === 200) {
        setBookingList1(response?.data?.data);
      } else {
        showToastError(response?.data || response.message);
      }
    } catch (error) {
      error?.data?.data &&
        showToastError(error?.data?.data || error.data?.message);
    }
  };

  const rescheduleSet = (date12) => {
    const myArray = date12.split(" ");

    setRescheduleStartTime(myArray[0]);
    setRescheduleEndTime(myArray[2]);
  };
  const rescheduleTimeSlots = async (date) => {
    if (!rescheduleTime) {
      // setError(true);
      // checkDaysDates()
    } else {
      // setError(false);
      try {
        const response = await rescheduleSlots({
          bookingDate: date1 ? date1 : format(date1, "yyyy-MM-dd"),
          startTime: rescheduleStartTime,
          endTime: rescheduleEndTime,
          bookingId: bookingId,
        });
        if (response.status === 200) {
          if (status !== "confirmed") confirmBooking(request);
          setDate(new Date());
          getTodaysBookingList1(moment(new Date(date)).format("YYYY-MM-DD"));
          await getTodaysBookingList(
            moment(new Date(date)).format("YYYY-MM-DD")
          );
          showToastSuccess("Booking rescheduled sucessfully.");
          setRescheduleTime("");
        } else {
          showToastError(response?.data || response.message);
        }
      } catch (error) {
        error?.data?.data &&
          showToastError(error?.data?.data || error.data?.message);
      }
    }
  };

  const handleNotes = (data) => {
    navigate("/viewappointmentnotes", { state: { appointmentObj: data } });
  };

  const showDetailsHandle = (dayStr) => {
    setDate1(changeDateFormatYYYY(dayStr));
    // setData(dayStr);
    // setShowDetails(true);
    // getRescheduleBookingList(changeDateFormatYYYY(dayStr))
  };

  const createMeeting = async (request) => {
    try {
      // const time24h = request?.startTime?.split('-')?.[0]?.trim();
      const params = {
        topic: "Doctor appointment",
        type: 2,
        start_time: request.startTime,
        duration: "30",
        settings: {
          host_video: true,
          participant_video: true,
          join_before_host: true,
          mute_upon_entry: "true",
          watermark: "true",
          audio: "voip",
          auto_recording: "cloud",
          email_notification: true,
          registrants_email_notification: true,
          meeting_invitees: [
            {
              email: request?.userId?.email,
            },
          ],
        },
      };
      const meetingResponse = await createZoomMeetingService(params);
      if (meetingResponse) {
        return meetingResponse;
      }
    } catch (error) {
      if (error?.data?.data) {
        navigate("/myprofile");
        showToastError(
          error?.data?.data || error.data?.message || "Some error occurred"
        );
      }
    }
  };

  const confirmBooking = async (req) => {
    const meetingResponse = await createMeeting(req);
    if (meetingResponse) {
      var sessionLink_doctor1 = meetingResponse.start_url;
      var sessionLink_user1 = meetingResponse.join_url;
    }
    try {
      const response = await confirmBookingStatus({
        bookingId: bookingId,
        status: "confirmed",
        message: confirmMessage,
        sessionLink_doctor: sessionLink_doctor1,
        sessionLink_user: sessionLink_user1,
      });
      if (response.status === 200) {
        showToastSuccess(response?.data?.message);
        setDate(new Date());
      } else {
        showToastError(response?.data || response.message);
      }
    } catch (error) {
      error?.data?.data &&
        showToastError(error?.data?.data || error.data?.message);
    }
  };

  const popover1 = (
    <Popover
      id="popover-basic"
      className="rounded"
      style={{ minWidth: "500px" }}
    >
      {/* <Popover.Header as="h3">Popover right</Popover.Header> */}
      <Popover.Body>
        {/* <h6 className='mb-3'>Calender - <span>{auth.authUser.full_name}</span></h6> */}
        <div className="px-1">
          <CalendarWeek
            showDetailsHandle={showDetailsHandle}
            date={date}
            setTimeList={setTimeList}
            setBookingList1={setBookingList1}
            sessionType={sessionType}
            serviceId={request.serviceId?._id}
          />
          {/* <br />
          {showDetails && <Details data={data} />} */}
          <div className="d-flex flex-row justify-content-between">
            <div
              className="col-md-6  card mt-2"
              style={{ backgroundColor: "#E3ECED" }}
            >
              <h5 className="description_btnsave px-5 mt-2 py-3">
                Availability{" "}
              </h5>
              <div className=" unavailable_list mt-1">
                {timeList.length ? (
                  timeList.map((dt, i) => (
                    <div
                      key={i}
                      className="d-flex flex-row align-items-center justify-content-start ms-3  px-4 "
                      style={{ borderColor: "#1f7e78" }}
                    >
                      {BookingList1.filter((dt1) => {
                        return formatAMPM(dt1.startTime).includes(
                          formatAMPM(dt.start)
                        );
                      }).length ? (
                        <></>
                      ) : (
                        <>
                          <input
                            name="slot"
                            key={dt._id}
                            id={dt._id}
                            type="radio"
                            onChange={() => {
                              rescheduleSet(dt.start + " - " + dt.end);
                              setRescheduleTime(
                                formatAMPM(dt.start) +
                                  " - " +
                                  formatAMPM(dt.end)
                              );
                            }}
                          />
                          <label
                            htmlFor={dt._id}
                            className="mb-1 ms-2"
                            style={
                              rescheduleTime !==
                              formatAMPM(dt.start) + " - " + formatAMPM(dt.end)
                                ? { color: "#1f7e78", cursor: "pointer" }
                                : { color: "darkblue", cursor: "pointer" }
                            }
                          >
                            {formatAMPM(dt.start) + " - " + formatAMPM(dt.end)}
                          </label>
                        </>
                      )}
                    </div>
                  ))
                ) : (
                  <p className="px-5">Slots not available</p>
                )}
              </div>
            </div>
            <div
              className="col-md-6  card mt-2 ms-2"
              style={{ backgroundColor: "#E3ECED" }}
            >
              <h5 className="description_btnsave px-5 mt-2 py-3">
                Booked Slots{" "}
              </h5>
              <div className=" unavailable_list mt-1">
                {BookingList1.length ? (
                  BookingList1.map((dt, i) => (
                    <div
                      key={i}
                      className="d-flex flex-row align-items-center justify-content-between ms-3 py-1 px-4 "
                      style={{ borderColor: "#1f7e78" }}
                    >
                      <p className="mb-0" style={{ color: "#1f7e78" }}>
                        {formatAMPM(dt.startTime) +
                          " - " +
                          formatAMPM(dt.endTime)}
                      </p>
                    </div>
                  ))
                ) : (
                  <p className="px-5 ms-1">No slots booked</p>
                )}
              </div>
            </div>
          </div>
          <div className="mt-3 ">
            <div className=" d-flex flex-row justify-content-center">
              <div>
                <button
                  onClick={() => {
                    if (rescheduleTime) {
                      setAttend("");
                      rescheduleTimeSlots(date);
                    }
                  }}
                  type="button"
                  className="description_btnsave  ms-5"
                  // data-bs-toggle="modal" data-bs-target="#rescheduleModal"
                >
                  Reschedule
                </button>
              </div>
            </div>
          </div>
        </div>
        {/* <DeleteModal
          title={'Reschedule'}
          content1={'Are you sure you want to reschedule'}
          content2={'this booking?'}
          modalId={'rescheduleModal'}
          button2={'No'}
          button1={'Yes'}
          onDelete={() =>
            rescheduleTimeSlots(date)
          }
        /> */}
      </Popover.Body>
    </Popover>
  );

  const popover = (
    <Popover
      id="popover-basic"
      className="rounded"
      style={{ minWidth: "300px" }}
    >
      {/* <Popover.Header as="h3">Popover right</Popover.Header> */}
      <Popover.Body>
        <h6 className="mb-3">
          Calender - <span>{auth.authUser.full_name}</span>
        </h6>
        <div className="px-2">
          <h3 className="text-capitalize">
            {sessionType} <span className="text-lowercase">with </span>{" "}
            {sessionWith}
          </h3>
          <p className="pt-1 mb-1">
            <AiOutlineClockCircle className="me-2 mb-1" />
            {format(date, "EEE, MM/dd/yyyy")}{" "}
            <span> {startTime + " - " + endTime}</span>{" "}
          </p>
          <p className="pt-1 mb-1 text-capitalize">
            <BsPersonCircle className="me-2 mb-1" />
            {sessionType === "group" ? "Group Session" : "Individual Session"}
          </p>

          <div className="mt-3 d-flex justify-content-between">
            {status === "pending" ? (
              <button
                onClick={() => setAttend("yes")}
                type="button"
                className="btn btn-sm btn-outline-light border border-dark text-dark"
              >
                <AiOutlineCheck className="text-success me-1 mb-1" />
                Confirm
              </button>
            ) : null}
            <OverlayTrigger
              trigger="click"
              placement="bottom"
              rootClose={true}
              overlay={popover1}
            >
              <button
                onClick={() => {
                  setAttend("reschedule");
                  setPopClose(false);
                }}
                type="button"
                className="btn btn-sm btn-outline-light border border-dark text-dark"
              >
                <MdClose className="text-danger me-1 mb-1" />
                Reschedule
              </button>
            </OverlayTrigger>
          </div>
        </div>

        {attend === "yes" && (
          <div className="p-2 mt-4">
            <h6>Yes I'll attend</h6>
            <div className="form-check">
              <input
                className="form-check-input"
                type="checkbox"
                id="flexCheckChecked"
                defaultChecked
                readOnly
              />
              <label className="form-check-label" for="flexCheckChecked">
                Notification to attendee's
              </label>
            </div>
            <div className="mb-3">
              {/* <label for="exampleFormControlTextarea1" className="form-label">Example textarea</label> */}
              <textarea
                className="form-control"
                id="exampleFormControlTextarea1"
                rows="3"
                onChange={(data) => {
                  setConfirmMessage(data.target.value);
                }}
              ></textarea>
            </div>
            <div className="mt-3 d-flex gap-2">
              <button
                onClick={() => {
                  setAttend("");
                  confirmBooking(request);
                }}
                type="button"
                className="btn btn-sm btn-primary"
              >
                <AiOutlineSend className="mb-1 me-1" />
                Send
              </button>
              <button
                onClick={() => setAttend("")}
                type="button"
                className="btn btn-sm btn-outline-light border border-secondary text-secondary"
              >
                <FaRegTrashAlt className="mb-1 me-1" />
                Discard
              </button>
            </div>
          </div>
        )}
      </Popover.Body>
    </Popover>
  );

  const handleConversion = (reminder) => {
    let time = format24Time(reminder.startTime) + ":00.000+05:30";
    return time;
  };

  const setReminder = async (reminder) => {
    const reminderTitle = `${
      reminder.type === "group" ? "Group session" : "Individual Session"
    } Appointment with ${reminder.userId.full_name} at ${moment(
      new Date(reminder.startTime)
    ).format("hh:mm a")}`;
    let params = {
      dateTime: handleConversion(reminder),
      title: reminderTitle, //Group session Appointment with full name at 11:40
      type: "reminder",
      isCompleted: [],
    };
    try {
      const response = await AddReminder(params);
      if (response.status === 200) {
        showToastSuccess("Reminder Created");
      } else {
        showToastError(
          response?.data || response.message || toastMsg.errorMssg
        );
      }
    } catch (error) {
      showToastError(
        error?.data?.data || error?.data?.message || toastMsg.errorMssg
      );
    }
  };

  const renderList = (list) => {
    const List = list.map((dt) => {
      return (
        <>
          <tr key={dt._id} className="text-center mt-5 ">
            {dt.type === "session" && (
              <>
                {dt?.users?.length > 0 ? (
                  dt.users.map((user) => (
                    <td className="resFont">{user?.full_name}</td>
                  ))
                ) : (
                  <td className="resFont">{dt.userId?.full_name}</td>
                )}
              </>
            )}
            <td className="resFont col-sm-1 col-md-1 col-lg-2">
              {dt.serviceId?.serviceName}
            </td>
            {/* {dt.type === "group" && <td className="resFont">{dt.serviceId?.attendees?.length}</td>} */}
            <td className="resFont">{dt?.bookingType}</td>
            <td className="resFont">{dt?.bookingDate}</td>
            <td className="text_unset resFont">
              {formatAMPM(dt.startTime) + " - " + formatAMPM(dt.endTime)}
            </td>
            {dt.type === "group" && (
              <td className="resFont">
                {`${
                  dt.users.filter((user) => user.status === "accept").length
                } / ${dt.serviceId?.attendeesLimit}`}
              </td>
            )}
            <td
              className="text-muted col-sm-1 col-md-1 col-lg-2 fw-bold text-left overflow-visible resFont"
              style={{ cursor: "pointer" }}
            >
              <div className="d-flex gap-2 justify-content-center resFont">
                {dt?.bookingType === "video" && (
                  <>
                    {" "}
                    <button
                      onClick={() => setLink(dt?.sessionLink_doctor)}
                      className="btn btn-light"
                      style={{
                        backgroundColor: "rgba(31, 126, 120, 0.05)",
                        color: "rgba(31, 126, 120)",
                      }}
                      disabled={dt?.status === "pending" ? true : false}
                    >
                      <span>
                        <AiFillCaretRight />
                      </span>
                    </button>
                    {/* <button
                      className="btn btn-light"
                      style={{
                        backgroundColor: "rgba(31, 126, 120, 0.05)",
                        color: "rgba(31, 126, 120)",
                      }}
                      onClick={() =>
                        updateAppointmentBooking({
                          bookingId: dt._id,
                          status: "cancelled",
                          message: " ",
                        })
                      }
                    >
                      <span>
                        <FcCancel />{" "}
                      </span>
                    </button> */}
                  </>
                )}
                {dt?.bookingType === "phone" && (
                  <>
                    {" "}
                    <button
                      className="btn btn-light"
                      style={{
                        backgroundColor: "rgba(31, 126, 120, 0.05)",
                        color: "rgba(31, 126, 120)",
                      }}
                      disabled={dt?.status === "pending" ? true : false}
                      onClick={() => setPhone(dt.serviceId?.phone)}
                    >
                      <span>
                        <AiFillPhone />
                      </span>
                    </button>
                  </>
                )}
                {dt?.bookingType === "inperson" && (
                  <>
                    {" "}
                    <button
                      className="btn btn-light"
                      style={{
                        backgroundColor: "rgba(31, 126, 120, 0.05)",
                        color: "rgba(31, 126, 120)",
                      }}
                      disabled={dt?.status === "pending" ? true : false}
                      onClick={() => setLocation(dt.serviceId?.location)}
                    >
                      <span>
                        <AiFillHome />
                      </span>
                    </button>
                  </>
                )}
              </div>
            </td>
            <td
              className="text-muted col-lg-2 col-sm-4 col-md-3 col-xl-2 fw-bold text-left overflow-visible"
              style={{ cursor: "pointer" }}
            >
              <div className="d-flex gap-2 justify-content-center">
                {dt.type === "session" ? (
                  <OverlayTrigger
                    onEnter={() => {
                      setAttend("");
                      setSessionType(dt.type);
                      setBookingId(dt._id);
                      setSessionWith(dt.userId ? dt.userId?.full_name : dt?.users ? dt?.users[0]?.full_name : "");
                      setStartTime(formatAMPM(dt.startTime));
                      setEndTime(formatAMPM(dt.endTime));
                      setRequest(dt);
                      setStatus(dt.status);
                      setDate(new Date(dt.bookingDate));
                      setPopClose(true);
                    }}
                    trigger="click"
                    placement="left"
                    rootClose={popClose}
                    overlay={popover}
                  >
                    <button
                      title="View Appointment"
                      className="btn btn-light"
                      style={{
                        backgroundColor: "rgba(31, 126, 120, 0.05)",
                        color: "rgba(31, 126, 120)",
                      }}
                    >
                      <AiFillEye />
                    </button>
                  </OverlayTrigger>
                ) : (
                  <button
                    className="btn btn-light"
                    title="View Group Appointment"
                    onClick={() => navigate('/groupparticipants',{state:{appointment:dt, isFromSchedule:false}})}
                    style={{
                      backgroundColor: "rgba(31, 126, 120, 0.05)",
                      color: "rgba(31, 126, 120)",
                    }}
                  >
                    <AiFillEye />
                  </button>
                )}
                {/* <button
                  className="btn btn-light"
                  title="Reschedule Appointment"
                  onClick={() => handleNotes(dt)}
                  style={{
                    backgroundColor: "rgba(31, 126, 120, 0.05)",
                    color: "rgba(31, 126, 120)",
                  }}
                >
                  <PiNoteFill />
                </button> */}
                <OverlayTrigger
                  onEnter={() => {
                    setAttend("");
                    setSessionType(dt.type);
                    setBookingId(dt._id);
                    setSessionWith(dt.userId ? dt.userId?.full_name : "");
                    setStartTime(formatAMPM(dt.startTime));
                    setEndTime(formatAMPM(dt.endTime));
                    setRequest(dt);
                    setStatus(dt.status);
                    setDate(new Date(dt.bookingDate));
                    setPopClose(true);
                  }}
                  trigger="click"
                  placement="left"
                  rootClose={true}
                  overlay={popover1}
                >
                  <button
                    className="btn btn-light"
                    title="Reschedule Appointment"
                    onClick={() => {
                      setAttend("reschedule");
                      setPopClose(false);
                      setDate(new Date(dt.bookingDate));
                    }}
                    style={{
                      backgroundColor: "rgba(31, 126, 120, 0.05)",
                      color: "rgba(31, 126, 120)",
                    }}
                  >
                    <PiNoteFill />
                  </button>
                </OverlayTrigger>
                <button
                  data-bs-toggle="modal"
                  data-bs-target="#individualdeleteSession"
                  title="Delete Appointment"
                  className="btn btn-light"
                  style={{
                    backgroundColor: "rgba(31, 126, 120, 0.05)",
                    color: "rgba(31, 126, 120)",
                  }}
                  onClick={() => setAppointId(dt._id)}
                >
                  <FaTrash />
                </button>
                <Dropdown>
                  <Dropdown.Toggle
                    variant="light"
                    className="custom"
                    id="dropdown-basic"
                    style={{
                      backgroundColor: "rgba(31, 126, 120, 0.05)",
                      color: "rgba(31, 126, 120)",
                    }}
                  >
                    <BsThreeDots />
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    <Dropdown.Item
                      onClick={() => {
                        navigate("/calender?tab=1");
                      }}
                    >
                      <Dropdown.ItemText>View in my schedule</Dropdown.ItemText>
                    </Dropdown.Item>
                    <Dropdown.Item>
                      <Dropdown.ItemText onClick={() => setReminder(dt)}>
                        Set Reminder
                      </Dropdown.ItemText>
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </div>
            </td>
          </tr>
        </>
      );
    });
    return List;
  };

  return (
    <>
      {" "}
      <Popup
        onClickBtn1={() => onStartSession(link)}
        show={link}
        onHide={() => setLink(null)}
        title={"Video"}
        modalId={"video"}
        content={
          <>
            <h3 className="text-center">Start video call? </h3>{" "}
            <span
              className="d-inline-block text-truncate"
              style={{ maxWidth: "100%" }}
            >
              {link}
            </span>{" "}
          </>
        }
        btn1={"yes"}
        btn2={"no"}
        position={"left"}
      />{" "}
      <Popup
        show={phone}
        onHide={() => setPhone(null)}
        title={"Phone"}
        modalId={"phone"}
        content={<h3 className="text-center">Call Now: {phone}</h3>}
        position={"left"}
      />{" "}
      <Popup
        show={location}
        onHide={() => setLocation(null)}
        title={"Location"}
        modalId={"inperson"}
        content={<h3 className="text-center">Address: {location}</h3>}
        position={"left"}
      />{" "}
      {renderList(dt)}
    </>
  );
}

export default PopoverList;
